import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import './App.css';
// import Menu from './AppMenu';
import { menuItems } from '../services/common/states';
import { getFilteredMenus } from '../common/helpers/permissions';
function AppSidebar() {
    const [appMenuItems, setAppMenuItems] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        var currentUser = JSON.parse(localStorage.getItem("user"));
        menuItems.subscribe(e => { setAppMenuItems(getFilteredMenus(e)); })
    }, [])

    const onMenuItemClicked = (item) => {
        const m = appMenuItems.map(x => {
            x['active'] = (x.label == item.label);
            return x;
        });
        menuItems.next(m);
        navigate(item.url);
    }

    const menu = appMenuItems.map(item => {
        return (
            <div key={'sb-' + item.label} className='col pt-0 pb-1' style={{ marginLeft: '-6px' }}>
                <Button
                    label={item.label} icon={"pi " + item.icon} iconPos="left"
                    className={'w-100 ' + (item.active ? 'p-button-primary' : 'p-button-text')}
                    onClick={() => onMenuItemClicked(item)}
                    style={{ textAlign: 'left', width: '172px' }} />
            </div>
        );
    })
    const useWindowDimensions = () => {
        const hasWindow = typeof window !== "undefined"

        function getWindowDimensions() {
            const width = hasWindow ? window.innerWidth : null
            const height = hasWindow ? window.innerHeight : null
            return {
                width,
                height,
            }
        }

        const [windowDimensions, setWindowDimensions] = useState(
            getWindowDimensions()
        )

        useEffect(() => {
            if (hasWindow) {
                function handleResize() {
                    setWindowDimensions(getWindowDimensions())
                }
                window.addEventListener("resize", handleResize)
                return () => window.removeEventListener("resize", handleResize)
            }
        }, [hasWindow])
        return windowDimensions
    }

    const { height, width } = useWindowDimensions()
    const breakpoint = 1000


    const menusidebar = appMenuItems.map(item => {
        return (
            <div className="contain-sidebar">
                {/* <button className="mob-header" onClick={() => onMenuItemClicked(item)} > */}
                <button
                    className={`mob-header ${item.active ? 'active' : ''}`}
                    onClick={() => onMenuItemClicked(item)}
                >

                    {/* <i className='pi pi-th-large'></i> */}
                    {/* <i className='{"pi" + item.icon}'></i> */}
                    <Button className='mob-icon' icon={"pi " + item.icon} />
                    <br />
                    <label className="mob-label" htmlFor="binary">{item.label}</label>
                </button>
            </div>
        );
    })

    return (
        <div>
            {width <= breakpoint ? (
                // <div className='p-grid p-fluid'>
                <Card className="mob-sidebar">
                    <div className="grid-sidebar">
                        {menusidebar}
                    </div>

                </Card>

                // </div>
            ) : (
                <div className='app-sidebar'>
                    <div className='logo'>
                        <a href='/'><img src='/assets/images/logo.png' /></a>
                    </div>
                    <div className='menu-wrapper ess-scroll'>
                        {menu}
                    </div>
                    {/* <div className='sidebar-footer'>
                        <div>@2022, Espire Infolab Pvt, Ltd.</div>
                        <div>All Rights Reserved</div>
                    </div> */}
                </div>
            )}
        </div>
    )
}

export default AppSidebar;